<template>
  <b-card :no-body="nobody">
    <div class="d-flex justify-content-between align-items-center mb-0 ss">
      <div class="d-flex align-items-center">
        <span class="text-nowrap ml-1">
          {{ $t("pagination.show_from") }}
        </span>
        <b-form-select
          v-model="pagination.page_size"
          :options="pageOptions"
          class="mx-1"
          @change="changePerPage"
        />
        <span class="text-nowrap"> {{ $t("pagination.lines") }} </span>
      </div>
      
      <b-pagination
        v-model="pagination.page"
        :total-rows="rows"
        :per-page="pagination.page_size"
        first-number
        last-number
        align="right"
        aria-controls=""
        prev-class="prev-item"
        next-class="next-item"
        class="mb-0"
        @change="changePage"
        limit="7"
      >
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>
    </div>
  </b-card>
</template>

<script>
import { BPagination, BFormSelect, BCard } from "bootstrap-vue";

export default {
  name: "Pagination",
  components: {
    BPagination,
    BFormSelect,
    BCard,
  },
  props: {
    rows: {
      type: Number,
      required: false,
      default: 1,
    },
    nobody: {
      type: Boolean,
      default: false,
      required: false,
    },
    params: {
      type: Object,
      default: () => ({
        page_size: 10,
        page: 1,
      }),
    },
    page: {
      type: [String, Number],
      required: false,
    },
    page_size: {
      type: [String, Number],
      required: false,
    },
    page_options: {
      type: [Array, Object],
      required: false,
      default: () => [3, 5, 10],
    },
  },
  data() {
    return {
      pageOptions: this.page_options,
      pagination: this.params,
    };
  },
  watch: {
    page(newValue){
      if(newValue){
        console.log(newValue)
        this.pagination.page = newValue
      }
    },
    page_size(newValue){
      if(newValue){
        this.pagination.page_size = newValue
      }
    }
  },
  methods: {
    changePerPage(size) {
      this.params.page_size = size;
      this.params.page = 1;
      this.$emit("refresh", this.params);
    },
    changePage(value) {
      this.params.page = value;
      this.$emit("refresh", this.params);
    },
  },
};
</script>
<style>
</style>
